import { render, staticRenderFns } from "./monitor-center-alert-bind.vue?vue&type=template&id=c0280fe4&scoped=true"
import script from "./monitor-center-alert-bind.vue?vue&type=script&lang=js"
export * from "./monitor-center-alert-bind.vue?vue&type=script&lang=js"
import style0 from "./monitor-center-alert-bind.vue?vue&type=style&index=0&id=c0280fe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0280fe4",
  null
  
)

export default component.exports